import * as React from 'react';
import { FaInfo } from 'react-icons/fa';
import { ButtonSecondary, CloseButton, ButtonPrimary, ElementLoader } from 'ui';
import { SelectedModal } from 'app/types-shared';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { HotKeys } from 'ui/common/hotkeys';
import styles from './regenerate-aggregated-modal.scss';

export interface RegenerateAggregatedModalProps {
  selectedModal: SelectedModal;
  translation?: any;
  onClose: () => void;
  fetchingRegenerateAggregated: boolean;
  executeRegenerateAggregatedTables: (endpoint: string) => void;
}

export class RegenerateAggregatedTablesModal extends React.PureComponent<RegenerateAggregatedModalProps, any> {
  public render() {
    const { selectedModal: { endpoint, description } = {},
      fetchingRegenerateAggregated, translation, executeRegenerateAggregatedTables } = this.props;

    const keyMap = {
      onClose: [keyCodeTypes.Esc]
    };

    const handlers = {
      onClose: () => this.props.onClose()
    };

    const onExecuteRegenerateAggregatedTables = () => executeRegenerateAggregatedTables(endpoint);

    return (
      <HotKeys keyMap={keyMap} handlers={handlers}>
        <div className={`modal ${styles.regenerateAggregatedModal}`}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5>
                  {translation.regenerate_aggregated_tables_title}
                </h5>
                <CloseButton data-dismiss="modal" onClick={this.props.onClose} />
              </div>
              <div className={`modal-body ${styles.regenerateAggregatedModalBody}`}>
                <div className={styles.disclaimerPanel}>
                  <FaInfo /> {translation.regenerate_aggregated_tables_info}
                </div>
                {fetchingRegenerateAggregated ? <div className={styles.loader}>
                  <ElementLoader />
                </div> : replaceTemplateString(translation.regenerate_aggregated_tables_description, description)}
              </div>
              <div className={`modal-footer ${styles.regenerateAggregatedModalFooter}`}>
                <ButtonSecondary dataDismiss="modal" onClick={this.props.onClose} disabled={fetchingRegenerateAggregated}>
                  {translation.regenerate_aggregated_cancel}
                </ButtonSecondary>
                <ButtonPrimary onClick={onExecuteRegenerateAggregatedTables} disabled={fetchingRegenerateAggregated}>
                  {translation.regenerate_aggregated_submit_button}
                </ButtonPrimary>
              </div>
            </div>
          </div>
          <div className="modal-background" onClick={this.props.onClose} />
        </div>
      </HotKeys>
    );
  }
}
